import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { HeaderComponent } from '../../shared/header/header.component';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { fromEvent, Subscription } from 'rxjs';
import { SidebarComponent } from "../../shared/sidebar/sidebar.component";
import { SidebarService } from '../../services/sidebar.service';

@Component({
    selector: 'quote-hub-main',
    standalone: true,
    imports: [CommonModule, HeaderComponent, RouterOutlet, SidebarComponent],
    templateUrl: './main.component.html',
    styleUrl: './main.component.scss'
})
export class MainComponent implements OnInit, OnDestroy {
  public sidebarService = inject(SidebarService);
  private popStateSub?: Subscription;

  ngOnInit() {
    history.pushState(null, '', location.href);
    this.popStateSub = fromEvent(window, 'popstate').subscribe(() => {
      history.pushState(null, '', location.href);
    });
  }

  ngOnDestroy() {
    this.popStateSub?.unsubscribe();
  }
}

